var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0156 21.671H24.075C26.9645 21.671 28.5792 20.3112 29.1741 17.5068L31.8086 5.09905C32.4885 1.95464 31.3837 0 28.0693 0H26.8795C24.16 0 22.4603 1.18978 21.5255 3.7393L17.1913 16.317C16.0865 19.5464 17.5312 21.671 21.0156 21.671ZM4.18871 21.671H7.24815C10.1376 21.671 11.7523 20.3112 12.3472 17.5068L14.9817 5.09905C15.6616 1.95464 14.5568 0 11.2424 0H10.0526C7.33313 0 5.63344 1.18978 4.69862 3.7393L0.364421 16.317C-0.740374 19.5464 0.704358 21.671 4.18871 21.671Z",
    fill: "#17255A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon);
export default __webpack_public_path__ + "static/media/quoteIcon.9126d20fb5bcf66769b9f319c6930d93.svg";
export { ForwardRef as ReactComponent };